import {
  getHrefLangRelatedToLocale,
  getProdHostnameByDevice,
  useConfig,
} from '@aboutyou/config';
import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import {Head} from '@aboutyou/head-elements';
import {useLocale, useTranslation} from '@aboutyou/i18n';
import {Redirect, useHistory} from '@aboutyou/router';
import {TrackContentPageView} from '@aboutyou/tracking';
import React, {FC} from 'react';
import {LaunchTeaserPage} from './LaunchTeaserPage';

export const LaunchTeaser: FC = () => {
  const locale = useLocale();
  const searchParams = useHistory().location.search;
  const {t} = useTranslation();
  const config = useConfig();
  const hrefLangs = getHrefLangRelatedToLocale(locale);
  const hostnames = getProdHostnameByDevice(hrefLangs, config.device);

  const isLaunchTeaserPageActive = useIsSoftFeatureToggleActive(
    'big_bang_launch_teaser_page',
  );

  if (!isLaunchTeaserPageActive) {
    const queryParams = new URLSearchParams(searchParams);
    queryParams.append('launch_teaser_redirect', '1');
    return <Redirect to={`/?${queryParams.toString()}`} />;
  }

  const pageTitle = t('WHO THE F*** IS');

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={t(
            'ABOUT YOU is coming soon · Kostenlose & schnelle Lieferung! · 60 Tage Rückgaberecht',
          )}
        />

        {hrefLangs.map(({hrefLang, locale}) => (
          <link
            key={`${hrefLang}-${locale}`}
            hrefLang={hrefLang}
            rel="alternate"
            href={`https://${hostnames[locale]}`}
          />
        ))}

        <link
          rel="alternate"
          media="only screen and (max-width: 640px)"
          href={`https://${config.hostname}`}
        />

        <link
          rel="canonical"
          href={`https://www.${config.hostname.replace(/m./g, '')}`}
        />
        <meta name="robots" content="index, follow" />
      </Head>
      <TrackContentPageView pageTitle={pageTitle} />
      <LaunchTeaserPage endDate={new Date('04/26/2022 00:00:00 GMT+0200')} />
    </>
  );
};
